export const debounce = (func, wait = 300) => {
  let timer

  return function (...args) {
    const context = this

    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

export const waitFor = (delay, callback = () => {}) =>
  new Promise((resolve) => setTimeout(() => {
    resolve(callback())
  }, delay))
